
import {Component, Prop, Vue} from 'vue-property-decorator'
import {CompanyListOfQuotaDto, CustomerListDto} from "@/api/customerManage";

@Component({
  name: 'CustomerCardApply'
})
export default class CustomerCardApply extends Vue {
  @Prop({ default: () => ({}) }) data!: CompanyListOfQuotaDto
}
